import { LifeConstants } from '@tymbe/schema/constants/life_constants';
import { Banner, BannerType } from '../../../../components/Banner/Banner';

type Props = {
  originalLives: number;
  newLives: number;
};

const getConsequence = ({
  originalLives,
  newLives,
}: Props): [BannerType, string] => {
  // increasing new lives
  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  |     o------|---->n      |
  */
  if (
    newLives > LifeConstants.onlyRescueShiftThreshold &&
    originalLives <= LifeConstants.onlyRescueShiftThreshold &&
    originalLives > LifeConstants.banThreshold
  ) {
    return ['success', 'Tymber se bude moci hlásit na všechny směny.'];
  }

  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  |     o----->n            |
  */
  if (
    newLives === LifeConstants.onlyRescueShiftThreshold &&
    originalLives < LifeConstants.onlyRescueShiftThreshold &&
    originalLives > LifeConstants.banThreshold
  ) {
    return ['success', 'Tymber se bude moci hlásit pouze na směny označené 💚 a přijímat nové pozvánky.'];
  }

  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  o------------|---->n      |
  */
  if (
    newLives > LifeConstants.onlyRescueShiftThreshold &&
    originalLives <= LifeConstants.banThreshold
  ) {
    return ['success', 'Tymberovi se zruší ban - bude se moci hlásit na všechny směny.'];
  }

  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  o------->n   |            |
  */
  if (
    newLives > LifeConstants.banThreshold &&
    newLives < LifeConstants.onlyRescueShiftThreshold &&
    originalLives <= LifeConstants.banThreshold
  ) {
    return [
      'success',
      'Tymberovi se zruší ban - bude se moci hlásit pouze na směny označené 💚.',
    ];
  }

  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  o----------->n            |
  */
  if (
    newLives === LifeConstants.onlyRescueShiftThreshold &&
    originalLives <= LifeConstants.banThreshold
  ) {
    return [
      'success',
      'Tymberovi se zruší ban - bude se moci hlásit pouze na směny označené 💚 a přijímat pozvánky.',
    ];
  }

  // decreasing new lives
  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  |            n<----o      |
  */
  if (
    newLives === LifeConstants.onlyRescueShiftThreshold &&
    originalLives > LifeConstants.onlyRescueShiftThreshold
  ) {
    return [
      'warning',
      'Tymber se bude moci hlásit pouze na směny označené 💚 a přijímat pozvánky. Současné přihlášené směny to nijak neovlivní.',
    ];
  }

  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  |      n<----|----o       |
  */
  if (
    newLives < LifeConstants.onlyRescueShiftThreshold &&
    newLives > LifeConstants.banThreshold &&
    originalLives >= LifeConstants.onlyRescueShiftThreshold
  ) {
    return [
      'warning',
      'Tymberovi se zruší přihlášené směny i pozvánky. Bude se moci hlásit pouze na směny označené 💚.',
    ];
  }

  /*
  -2 (ban)    0 (rescue)    +3
  |            |            |
  n<------o----o-----o      |
  */
  if (newLives <= LifeConstants.banThreshold &&
    originalLives > LifeConstants.banThreshold) {
    return ['error', 'Tymber dostane ban, zruší se mu přihlášené směny i pozvánky. Nebude se moci přihlásit na žádnou směnu.'];
  }

  if (
    newLives <= LifeConstants.banThreshold &&
    originalLives <= LifeConstants.banThreshold
  ) {
    return ['info', 'Tymberovi zůstává ban.'];
  }

  return ['info', 'Žádná změna'];
};

export const TyLivesConsequenceInfo = ({ originalLives, newLives }: Props) => {
  const [type, consequence] = getConsequence({ originalLives, newLives });

  return <Banner type={type} title="Změna způsobí" message={consequence} />;
};
